import React from 'react';
import { render } from 'react-dom';

import {BrowserRouter as Router, Route, Switch} from "react-router-dom";
import './_root.css' ;

import WieldyComponent from "root/Wieldy/WieldyComponent";
import ChildApplicationComponent from "root/ChildApplication/ChildApplicationComponent";
import GlobalProvider from "root/contexts/GlobalProvider";
import LoginPage from "root/Login/LoginPage";
import {RecoilRoot} from "recoil";

import {PATH_HOME_ROOT, PATH_ROOT} from "root/Wieldy/routePaths";
import {PATH_CHILD_APPLICATION_ROOT} from "root/ChildApplication/routePaths";

const ArcCommunicationsApp = (props) =>
{
    const addArcomStyle = () =>
    {
        const overrideStylesheet = document.createElement('link');
        overrideStylesheet.rel = 'stylesheet';
        overrideStylesheet.href = "/app/assets/css/arcom_css.css";
        document.head.append(overrideStylesheet);

        const themeStylesheet = document.createElement('link');
        themeStylesheet.rel = 'stylesheet';
        themeStylesheet.href = "/app/assets/css/arcom.css";
        document.head.append(themeStylesheet);
    }

    return (
        <RecoilRoot>
            <div className="App">
                <GlobalProvider>
                    <Router basename={'/arcom'}>
                        <Switch>
                            <Route path={PATH_HOME_ROOT} render={(props) => <WieldyComponent {...props} />}/>
                            <Route path={PATH_CHILD_APPLICATION_ROOT} render={(props) => <ChildApplicationComponent {...props} />}/>
                            <Route path={PATH_ROOT} render={(props) => <LoginPage {...props} />}/>
                        </Switch>
                    </Router>
                </GlobalProvider>
            </div>
        </RecoilRoot>
    )
}

render(<ArcCommunicationsApp/>, document.getElementById('react-postbox'));
